import Modal from "../../../../parts/modal-new";

const id = "modal-add-contract";
const form = "add-contract";

const AddContract = ({ workflow }) => {
  return (
    <form
      action="/actions/getting-started/add-contract"
      method="POST"
      data-noreset
      id={form}
    >
      <input type="hidden" name="option" value="contract" />
      <input type="hidden" name="workflow" value={workflow._id} />

      <Modal
        name={id}
        key={id}
        title="Contract"
        className="getting-started-video"
      >
        <div className="body">
          <div className="form-row-item">
            <label className="sub-label" htmlFor="contract">
              Contract
            </label>
            <textarea
              type="text"
              name="contract"
              placeholder="Enter your contract here"
              defaultValue={workflow.options.contract?.contract}
              form={form}
              className="resize-y"
              rows={25}
              cols={70}
            />
          </div>
        </div>

        <footer className="foot">
          <button data-button-type="primary" type="submit">
            Add
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default AddContract;
